<button
  mat-fab
  [matMenuTriggerFor]="createMenu"
  aria-label="Create New"
  class="create-fab">
  <app-icon icon="add"></app-icon>
</button>

<mat-menu #createMenu="matMenu" [overlapTrigger]="false" class="create-menu">
  @if (displayCreateShipment$ | async) {
    <button mat-menu-item (click)="createShipment()">
      <app-icon icon="shipment"></app-icon>
      <span class="ml-2" i18n>Create New Shipment</span>
    </button>
  }
  @if (displayDuplicateShipment$ | async) {
    <button mat-menu-item (click)="duplicateShipment()">
      <app-icon icon="copy"></app-icon>
      <span class="ml-2" i18n>Duplicate This Shipment</span>
    </button>
  }
  @if (displayReturnShipment$ | async) {
    <button mat-menu-item (click)="returnShipment()">
      <app-icon icon="return"></app-icon>
      <span class="ml-2" i18n>Create Return Shipment</span>
    </button>
  }
  @if (displayCreateContact$ | async) {
    <button mat-menu-item (click)="createContact()">
      <app-icon icon="address-card"></app-icon>
      <span class="ml-2" i18n>Create New Contact</span>
    </button>
  }
  @if (displayCreateLibraryTemplate$ | async) {
    <button mat-menu-item (click)="createPackageTemplate()">
      <app-icon icon="package-library"></app-icon>
      <span class="ml-2" i18n>Create New Package Template</span>
    </button>
    <button mat-menu-item (click)="createCommodityTemplate()">
      <app-icon icon="seedling"></app-icon>
      <span class="ml-2" i18n>Create New Commodity Template</span>
    </button>
  }
</mat-menu>
